import React, { useEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { commerceOrdersLoad } from '../../../redux/actions/Commerce';
var renderWrapper = function renderWrapper(props) {
  return /*#__PURE__*/React.createElement("table", {
    className: "Orders"
  }, props.children);
};
var renderHeader = function renderHeader() {
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Order number:"), /*#__PURE__*/React.createElement("th", null, "Status:"), /*#__PURE__*/React.createElement("th", null, "Number of products:"), /*#__PURE__*/React.createElement("th", null, "Total price:")));
};
var renderItem = function renderItem(_ref) {
  var order = _ref.order;
  return /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    key: order.get('id')
  }, /*#__PURE__*/React.createElement("td", null, "#", order.getIn(['attributes', 'order_number'])), /*#__PURE__*/React.createElement("td", null, order.getIn(['attributes', 'state'])), /*#__PURE__*/React.createElement("td", null, order.getIn(['relationships', 'order_items', 'data'], Immutable.List()).count()), /*#__PURE__*/React.createElement("td", null, order.getIn(['attributes', 'balance', 'formatted']))));
};
var renderEmpty = function renderEmpty() {
  return /*#__PURE__*/React.createElement("div", null, "You have no previous orders.");
};
var Orders = function Orders(_ref2) {
  var wrapper = _ref2.wrapper,
    item = _ref2.item,
    header = _ref2.header,
    empty = _ref2.empty;
  var dispatch = useDispatch();
  useEffect(function () {
    dispatch(commerceOrdersLoad());
  }, []);
  var orders = useSelector(function (state) {
    return state.getIn(['commerce', 'orders'], Immutable.List());
  });
  if (orders.count() === 0) {
    var Empty = empty;
    return /*#__PURE__*/React.createElement(Empty, null);
  }
  var OrdersWrapper = wrapper;
  var OrdersHeader = header;
  var OrderItem = item;
  return /*#__PURE__*/React.createElement(OrdersWrapper, null, /*#__PURE__*/React.createElement(OrdersHeader, null), orders.map(function (order) {
    return /*#__PURE__*/React.createElement(OrderItem, {
      order: order
    });
  }));
};
Orders.propTypes = {
  wrapper: PropTypes.element,
  header: PropTypes.func,
  item: PropTypes.func,
  empty: PropTypes.func
};
Orders.defaultProps = {
  wrapper: renderWrapper,
  header: renderHeader,
  item: renderItem,
  empty: renderEmpty
};
export default Orders;